import { useEffect } from 'react';
// import { clearInlineThemeStyles } from '../utils/clearInlineStyles';

/**
 * Component that selectively clears problematic inline CSS custom properties from the HTML element
 * This prevents the theme system from adding inline styles to the <html> tag while preserving functionality
 */
const StyleCleaner = () => {
  useEffect(() => {
    // Only clear inline styles on the HTML element, not on other elements
    const cleanHTMLInlineStyles = () => {
      const htmlElement = document.documentElement;
      
      // Check if HTML element has inline styles
      if (htmlElement.style.length > 0) {
        console.log('StyleCleaner: Detected inline styles on HTML element, clearing...');
        
        // Clear only CSS custom properties that might be problematic
        const propertiesToClear = [
          '--sidebar-bg-color',
          '--sidebar-text-color', 
          '--sidebar-icon-color',
          '--sidebar-active-bg-color',
          '--sidebar-active-text-color',
          '--sidebar-hover-bg-color',
          '--sidebar-hover-text-color',
          '--sidebar-border-color',
          '--sidebar-width',
          '--tabs-bg-color',
          '--tabs-text-color',
          '--tabs-active-bg-color',
          '--tabs-active-text-color',
          '--tabs-hover-bg-color',
          '--tabs-hover-text-color',
          '--bs-primary',
          '--bs-secondary',
          '--bs-accent',
          '--block-title-bg-color',
          '--block-title-color',
          '--theme-primary-color',
          '--theme-secondary-color',
          '--theme-accent-color'
        ];
        
        propertiesToClear.forEach(property => {
          htmlElement.style.removeProperty(property);
        });
        
        // If we've removed all styles, remove the style attribute entirely
        if (htmlElement.style.length === 0) {
          htmlElement.removeAttribute('style');
        }
      }
    };
    
    // Clean immediately on mount
    cleanHTMLInlineStyles();
    
    // Set up a MutationObserver to watch for any changes to the HTML element's style attribute
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && 
            mutation.attributeName === 'style' && 
            mutation.target === document.documentElement) {
          console.log('StyleCleaner: Detected inline style change on HTML element, cleaning...');
          // Use a timeout to avoid infinite loops
          setTimeout(cleanHTMLInlineStyles, 10);
        }
      });
    });
    
    // Start observing the HTML element for style attribute changes
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style']
    });
    
    // Set up a less frequent interval as backup
    const intervalId = setInterval(() => {
      cleanHTMLInlineStyles();
    }, 5000); // Check every 5 seconds
    
    // Clean up on unmount
    return () => {
      clearInterval(intervalId);
      observer.disconnect();
    };
  }, []);

  // This component doesn't render anything
  return null;
};

export default StyleCleaner; 